import i18n from "@/I18n/";
const Trans = {
    get supportedLocales() {
        return [
            { code: "ar", flag: "sa" },
            { code: "fr", flag: "fr" },
            { code: "en", flag: "us" },
        ];
    },
    get defaultLocale() {
        return "ar";
    },
    currentLocale(newLocale) {
        i18n.global.locale.value = newLocale;
    },
    isLocaleSupported(locale) {
        return (
            Trans.supportedLocales.filter((l) => l.code === locale).length > 0
        );
    },
    getUserLocale() {
        const locale =
            window.navigator.language ||
            window.navigator.userLanguage ||
            Trans.defaultLocale;
        return {
            locale: locale,
            localeNoRegion: locale.split("-")[0],
        };
    },
    localeChangeCallbacks: [],
    onLocaleChange(callback) {
        this.localeChangeCallbacks.push(callback);
    },
    getPersistedLocale() {
        const persistedLocale = localStorage.getItem("user-locale");
        if (Trans.isLocaleSupported(persistedLocale)) {
            return localStorage.getItem("user-locale");
        }
        return "fr";
    },
    async switchLanguage(newLocale) {
        window.location.reload();

        // document.querySelector("html").setAttribute("lang", newLocale);
        // document
        //     .querySelector("html")
        //     .setAttribute("dir", newLocale == "ar" ? "rtl" : "ltr");
        // document
        //     .querySelector(".swiper")
        //     ?.setAttribute("dir", newLocale == "ar" ? "rtl" : "ltr");

        // if (newLocale == "ar") {
        //     document.querySelector(".swiper")?.classList.add("swiper-rtl");
        // } else {
        //     document.querySelector(".swiper")?.classList.remove("swiper-rtl");
        // }

        localStorage.setItem("user-locale", newLocale);
        window.axios.defaults.headers.common["X-localization"] = `${newLocale}`;
        this.localeChangeCallbacks.forEach((callback) => callback(newLocale));
    },

    async switchLoginLanguage(newLocale) {
        localStorage.setItem("user-locale", newLocale);
        window.axios.defaults.headers.common["X-localization"] = `${newLocale}`;
        i18n.global.locale.value = newLocale;

        document.querySelector("html").setAttribute("lang", newLocale);
        document
            .querySelector("html")
            .setAttribute("dir", newLocale == "ar" ? "rtl" : "ltr");
        document
            .querySelector(".swiper")
            ?.setAttribute("dir", newLocale == "ar" ? "rtl" : "ltr");

        if (newLocale == "ar") {
            document.querySelector(".swiper")?.classList.add("swiper-rtl");
        } else {
            document.querySelector(".swiper")?.classList.remove("swiper-rtl");
        }
        this.localeChangeCallbacks.forEach((callback) => callback(newLocale));
    },
};
export default Trans;
